<template lang="pug">
v-layout.px-5.py-0(row wrap)
    //- Drawer to display video library and video preview/edit
    slide-drawer(
      :confirm-dismiss="confirmDismiss"
      ref="slide-drawer"
      v-model="showSlideDrawer"
      @input="handleReset"
    )
      template(slot="title") Video Library
      template(slot="content")
        video-library(
          @click-ld-video="handleShowVideo"
          @edit-ld-video="handleShowVideo"
          @insert-ld-video="insertLdVideo"
          communicationType="text"
          v-if="showVideoLibrary"
          ref="videoLibrary"
        )

        chat-video-detail.mx-4.mt-4.pr-5(
          :chatVideo="videoClicked"
          :isVideoEditable="isVideoEditable"
          :showVideoDetail="showVideoDetail"
          @modified:video="confirmDismiss = true"
          is-email-composer=true
          v-if="showVideoDetail"
        )

      template(slot="actions")
        v-btn(
          v-if="showVideoDetail && !isVideoEditable"
          class="primary--text"
          @click="handleActivateVideoEdit"
        ) Edit

        v-btn.primary(
          v-if="showVideoDetail && isVideoEditable"
          @click="handleVideoUpdate(videoClicked)"
        ) Save

        v-btn.mr-4(
          v-if="showVideoDetail && !isVideoEditable" color="primary"
          @click="insertLdVideo(videoClicked)"
        ) Select


    liondesk-content-editor(
      :outline-field="true"
      label="Insert text here..."
      field-type="textarea"
      ref-name="messageField"
      ref="messageField"
      v-model="body"
      rows=20
    )
      span(slot="suggestion")
        span.font-weight-bold {{ randomSuggestion.message }} 
          span.font-weight-bold(v-html="randomSuggestion.cta")
      span(slot="activator-top-texts-insert-content")
        v-btn.title-case(flat color="primary") Insert Liondesk Content

      span(slot="activator-top-texts-insert-video")
        v-btn.title-case(flat color="primary" @click="handleVideoLibrary") Insert Liondesk Video

      span(slot="activator-top-texts-insert-image")
        v-btn.title-case(flat color="primary") Insert Image
</template>
<script>

import { createNamespacedHelpers } from 'vuex';

import LiondeskContentEditor from '@/Communications/components/LiondeskContentEditor';
import LiondeskDialog from '@/Core/components/LiondeskDialog';
import Media from '@/Media/mixins/media';
import SlideDrawer from '@/Core/components/SlideDrawer';
import toggleSlideDrawer from '@/Core/mixins/toggle-slide-drawer';
import VideoLibrary from '@/Media/components/VideoLibrary';

import ChatVideoDetail from './ChatVideoDetail';


const {
  mapState: mapTemplatesState,
  mapActions: mapTemplatesActions,
} = createNamespacedHelpers('templates');

const {
  mapState: mapVideosState,
  mapActions: mapVideosActions,
} = createNamespacedHelpers('videos');

export default {
  components: {
    ChatVideoDetail,
    LiondeskContentEditor,
    LiondeskDialog,
    SlideDrawer,
    VideoLibrary,
  },
  mixins: [Media, toggleSlideDrawer],
  data() {
    return {
      // The body of the editor
      body: '',
      suggestions: [
        {
          message: 'Could your texts be getting flagged for spam? ',
          cta: '<a href="https://lonewolf.my.site.com/s/article/LD-Best-practices-for-texting-in-LionDesk" target="_blank">Mistakes you could be making.</a>',
        },
        {
          message: "What's the right way to start a text conversation? ",
          cta: '<a href="https://lonewolf.my.site.com/s/article/LD-Compliant-first-message-templates-after-obtaining-consent-LionDesk" target="_blank">Friendly templates to get you started.</a>',
        },
        {
          message: 'Why your texts might not get delivered - ',
          cta: '<a href="https://lonewolf.my.site.com/s/article/LD-Failed-texts-due-to-message-filtering-and-carrier-filtering-LionDesk" target="_blank">Content to avoid.</a>',
        },
      ],
    };
  },

  props: {
    // The value of the template body given from the parent
    value: {
      type: Object,
      default: {},
    },
  },

  computed: {
    ...mapTemplatesState([
      'toSelected',
      'templatesInProgress',
      'isEditing',
    ]),
    ...mapVideosState(['videos']),
    randomSuggestion() {
      return this.suggestions[Math.floor(Math.random()*this.suggestions.length)];
    },
  },

  watch: {
    /**
     * Watches for any changes in the prop and change the body accordingly
     */
    value(value) {
      this.body = value.body;
    },
    /*
     * This watches if there are any changes to the template body
     */
    body(value) {
      if (this.isTemplateFieldChanged(value, 'body')) {
        // Sets the editing boolean to true, indicating that the body has been modified.
        this.setEditing(true);
      }
      this.setBody(value);
    },
  },

  created() {
    // Initializes the body with the prop
    if (this.value) {
      this.body = this.value.body;
    }
  },

  methods: {
    ...mapTemplatesActions([
      'setBody',
      'setEditing',
    ]),
    ...mapVideosActions(['editVideo']),
    /*
     * @param {Any}      [value] This is the desired value that we want to compare
     * @param {String}   [field] This is the desired field that we want to compare against
     * @return {Boolean} The boolean indicating whether a field has been edited or not
     *
     * This helper function is to check wheteher a value has changed or not.
     * As well as whether the desired field has been edited of not
     */
    isTemplateFieldChanged(value, field) {
      return (
        value &&
        this.desiredTemplate &&
        value !== this.desiredTemplate[field] &&
        this.isEditing === false
      );
    },
    handleVideoUpdate(videoUpdated) {
      this.editVideo({ video: videoUpdated });
      this.closeSlideDrawer(false);
    },
    handleReset() {
      if (this.$refs.videoLibrary) {
        this.$refs.videoLibrary.reset();
      }
    },
    insertLdVideo(selectedVideo) {
      this.$refs.messageField.insertLDContent(this.formatInsertVideo(selectedVideo));
      this.closeSlideDrawer(false);
    },
  },
};

</script>
